import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setPreloader } from '../../../features/Ui/uiSlice';
import { swal } from '../../../helper/swal';
import { enquiry } from '../../../helper/api_url';
import { useModalHandler } from '../../../helper/custom_hook';
import { formatDate } from '../../../helper/formatDate';

export function FollowUpBtn(data) {
    const dispatch = useDispatch();
    const { status, toggleModal } = useModalHandler();

    const follow = data.follow || {};
    const enq = follow.enquiry || {};

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(setPreloader({ loader: true, message: 'Recording follow-up, please wait...' }));
        const formData = new FormData(e.target);
        enquiry.addFollow(formData)
            .then((res) => {
                toggleModal();
                swal.success(res.data.message || 'Follow-up recorded successfully!');
                if (data.onSuccess) data.onSuccess(res.data.followup);
            })
            .catch((err) => swal.error(err.response?.data?.message || err.message))
            .finally(() => dispatch(setPreloader({ loader: false, message: '' })));
    };

    return (
        <>
            <button
                type="button"
                onClick={toggleModal}
                className="btn btn-sm btn-soft-success py-1 px-2.5 d-inline-flex align-items-center fw-medium"
                title="Record Follow-Up"
            >
                <i className="ri-user-follow-line me-1 fs-12" />
                Follow
            </button>

            <Modal className="fade" centered backdrop="static" show={status} onHide={toggleModal} size="md">
                {/* Clean Header */}
                <Modal.Header closeButton className="border-bottom py-3 px-4 bg-light-subtle">
                    <div>
                        <h5 className="modal-title fs-15 fw-bold text-dark mb-0.5">Record Follow-Up</h5>
                        <div className="d-flex align-items-center gap-1.5 flex-wrap">
                            <span className="text-muted fs-12">
                                School: <strong className="text-dark">{enq.name || 'Candidate'}</strong>
                            </span>
                            {enq.course?.name && (
                                <span className="badge bg-soft-primary text-primary fs-11 px-2 py-0.5">
                                    {enq.course.name}
                                </span>
                            )}
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-4">
                    <form onSubmit={handleSubmit}>
                        <input type="hidden" name="enquiry_id" defaultValue={enq.id} />

                        {/* Previous Remark Context */}
                        {follow.remark ? (
                            <div className="context-note-card mb-3">
                                <div className="d-flex align-items-center justify-content-between mb-1.5">
                                    <span className="fs-11 fw-bold text-uppercase text-muted">
                                        Last Follow-Up Note
                                    </span>
                                    {follow.joining_date && (
                                        <span className="text-muted fs-11">
                                            {formatDate(follow.joining_date)}
                                        </span>
                                    )}
                                </div>
                                <div className="fs-13 text-dark lh-base" style={{ whiteSpace: 'pre-wrap' }}>
                                    {follow.remark}
                                </div>
                            </div>
                        ) : null}

                        <div className="row g-3">
                            {/* Next Follow Up Date */}
                            <div className="col-12 col-md-6">
                                <label htmlFor="joining_date" className="form-label fs-12 fw-semibold text-dark mb-1">
                                    Next Follow-Up Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control fs-13"
                                    id="joining_date"
                                    name="joining_date"
                                    defaultValue={follow.joining_date || ''}
                                    required
                                />
                            </div>

                            {/* Status */}
                            <div className="col-12 col-md-6">
                                <label htmlFor="follow_status" className="form-label fs-12 fw-semibold text-dark mb-1">
                                    Follow-Up Status <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select fs-13"
                                    id="follow_status"
                                    name="status"
                                    defaultValue={follow.status || 'pending'}
                                >
                                    <option value="pending">Pending (Follow-up again)</option>
                                    <option value="postpond">Meeting Arrange</option>
                                    <option value="completed">Completed / Converted</option>
                                    <option value="deleted">Not Interested</option>
                                </select>
                            </div>

                            {/* Conversation Remarks */}
                            <div className="col-12">
                                <label htmlFor="follow_remark" className="form-label fs-12 fw-semibold text-dark mb-1">
                                    Conversation Notes / Remark <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    name="remark"
                                    id="follow_remark"
                                    className="form-control fs-13"
                                    rows="3"
                                    placeholder="Enter conversation details, client feedback, or demo requirements..."
                                    required
                                />
                            </div>
                        </div>

                        {/* Footer Action Buttons */}
                        <div className="d-flex align-items-center justify-content-end gap-2 mt-4 pt-2 border-top">
                            <button type="button" className="btn btn-sm btn-light px-3" onClick={toggleModal}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-sm btn-primary px-3 fw-medium">
                                Save Follow-Up
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FollowUpBtn;